function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50.22 45.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-375.81,358.2l-8.54-8.55c-.86-.84-2.22-.84-3.08,0-.41,.41-.65,.97-.65,1.55s.23,1.14,.65,1.55l8.54,8.54c.82,.82,1.93,1.29,3.09,1.29s2.27-.46,3.09-1.29l20.17-20.17c.41-.41,.64-.96,.64-1.54s-.23-1.13-.64-1.54c-.41-.41-.96-.64-1.54-.64s-1.13,.23-1.54,.64l-20.19,20.17Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -398.97,
    y: 404.32,
    width: 55.37,
    height: 55.37,
    rx: -144.12,
    ry: -144.12,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -301.28,
    cy: 432,
    r: 28.2,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M29.34,4.77c0-2.34-2.72-3.62-4.53-2.13L10.33,14.6H5.47c-1.92,0-3.47,1.56-3.47,3.47v9.89c0,1.92,1.56,3.47,3.47,3.47h5.28l14.06,11.62c1.8,1.49,4.53,.21,4.53-2.13V4.77Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.07,13.98s2.88,4.05,2.88,8.87-2.88,8.87-2.88,8.87",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.32,5.86s6.9,5.69,6.9,16.99-6.9,16.91-6.9,16.91",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.e618ebd3.svg";
export { ForwardRef as ReactComponent };